import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import {
  FetchCreateOrEditInactiveHorseRegistrationRequestServiceRequestthunk,
  FetchGetServiceDefinitionByIdthunk,
  FetchGetServicesRequestByIdthunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
  resetGetServicesRequestByIdData,
  resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import dayjs from "dayjs";
import { FetchOwnerHorsesDropDownthunk } from "../Redux/OwnerProfile/OwnerProfileAction";
import EahsForm from "../components/EahsForm";
import PillBtn from "../components/PillBtn";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import SubmitAndPay from "../components/servicesButtons/SubmitAndPay";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import { eFormButtonsContainer, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";

export default function InactiveHorseRegistrationRequest() {
  //env
  const UMBRACOURL = process.env.REACT_APP_UMBRACO;
  //const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
  const BaseURL = process.env.REACT_APP_BASE_URL;

  //selector
  const { currentLanguage } = useSelector((state) => state.studBookSlice);

  const {
    toasterMessageServicesRequests,
    servicesRequestsLoading,
    getServicesRequestByIdData,
    getServiceDefinitionByIdData,
    createOrEditInactiveHorseRegistrationRequestData
  } = useSelector((state) => state.servicesRequestsSlice);

  const { ownerHorsesDropDownData } = useSelector(
    (state) => state.ownerProfileSlice
  );

  const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
  const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

  const dispatch = useDispatch();

  const { translate } = useTranslate();

  const navigate = useNavigate();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const serviceId = searchParams.has("serviceId")
    ? searchParams.get("serviceId")
    : null;

  const id = searchParams.has("id") ? searchParams.get("id") : null;

  const action = searchParams.has("action") ? searchParams.get("action") : null;
  const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

  //state
  const [formModel, setFormModel] = useState({
    id: "",
    eventName: "",
    comment: "",
    referenceNumber: "",
    requestsType: "",
    paymentStatus: "",

    horse: "",
    horseDrop: {
      label: translate("web.horse", "Horse"),
      value: null,
    },

    gender: "",
    color: "",
    birthDate: "",
    origin: "",
    breeder: "",
    sire: "",
    dam: "",

    reasons: "",

    ownerComment: "",
  });

  const [errorHorse, setErrorHorse] = useState(false);
  const [errorReasons, setErrorReasons] = useState(false);

  //use ref
  const horseRef = useRef(null);
  const reasonRef = useRef(null);

  const _isOnlinePayment = useRef("");
  const _status = useRef("");

  const [checkedItems, setCheckedItems] = useState({});

  // const [checkedItems, setCheckedItems] = useState({
  //   option1: false,
  // });

  const [profile, setProfile] = useState({
    label:
      !!userProfile &&
      userProfile?.ownerRegisterNo +
      " - " +
      userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
    value: localStorage.getItem("EAHSUserID"),
  });

  const subAccountId = localStorage.getItem("currentSubAccountId");

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
    }),
  };

  //function

  const handleFormChange = (e, input) => {
    if (input === "horse") {
      let horse = ownerHorsesDropDownData.filter((item) => item.id == e.value);

      if (horse.length > 0) {
        setFormModel({
          ...formModel,
          horse: e.value,
          horseDrop: e,
          birthDate: dayjs(horse[0]?.birthDate ?? "").format('DD/MM/YYYY'),
          color: horse[0]?.color ?? "",
          gender: horse[0]?.gender ?? "",
          sire: horse[0].sire,
          dam: horse[0].dam,
          origin: horse[0].origin,
          breeder: horse[0].breeder,
        });
      }
      else {
        setFormModel({
          ...formModel,
          horse: "",
          horseDrop: {
            label: translate("web.horse", "Horse"),
            value: null,
          },
          birthDate: "",
          color: "",
          gender: "",
          origin: "",
          breeder: "",
          sire: "",
          dam: "",
        });
      }
    }
    else {
      setFormModel({
        ...formModel,
        [e.target.name]: e.target.value,
      });
    }
  };

  const validInputs = () => {
    let valid = true;

    if (
      formModel.horse === ""
    ) {
      setErrorHorse(true);
      valid = false;

      horseRef?.current?.focus();
      return;
    }
    else {
      setErrorHorse(false);
    }

    if (
      formModel.reasons === ""
    ) {
      setErrorReasons(true);
      valid = false;

      reasonRef?.current?.focus();
      return;
    }
    else {
      setErrorReasons(false);
    }

    //term
    if (Object.values(checkedItems).length > 0) {  // Optional safe check
      const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

      if (!allTermsChecked && action == null) {
        toast.error(
          translate("web.pleaseCheckAllTerms", "Please Check All Terms")
        );
        valid = false;
      }
    }

    // if (
    //   !checkedItems.option1
    // ) {
    //   toast.error(
    //     translate("web.pleaseCheckTerm", "Please Check Term")
    //   );
    //   valid = false;
    // }

    return valid;
  }

  const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
    if (getServiceDefinitionByIdData.serviceFees > 0 && formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice" && formModel.eventName !== "SentBack") {
      const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

      const encodeURI = encodeURIComponent(returnUrl);

      window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=17&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
    }
    else {
      if (
        validInputs()
      ) {
        _isOnlinePayment.current = isOnlinePayment;
        _status.current = status;

        let params = {
          id: id,
          ownerId: getUserID(),
          horse: formModel.horse,
          reasons: formModel.reasons,
          status: status,
          ownerComment: formModel.ownerComment,
          buttonAction: buttonAction
        };

        dispatch(FetchCreateOrEditInactiveHorseRegistrationRequestServiceRequestthunk(params));
      }
      else {
        toast.error(
          translate("web.completeTheRequiredData", "Complete The Required Data")
        );
      }
    }
  };

  const handelSelectedAccountChange = async (element) => {
    let params = {
      ownerId: element.value,
      skip: 0,
      take: 1000,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: "",
      sortBy: "-1",
    };
    dispatch(FetchOwnerHorsesDropDownthunk(params));

    setProfile(element);

    setFormModel({
      ...formModel,
      horse: "",
      horseDrop: {
        label: translate("web.horse", "Horse"),
        value: null,
      },

      birthDate: "",
      color: "",
      gender: "",
      origin: "",
      breeder: "",
      sire: "",
      dam: "",

      reasons: "",
    });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setCheckedItems((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  function CheckIfAgentHasPermission() {
    const AgentHasPermission = userProfile.subAccounts
      .filter((x) => x.value == subAccountId)[0]
      .ownersPermissionsList.some(
        (x) =>
          x.permissionName === "InactiveHorseRegistrationRequest" || x.permissionName === "All"
      );
    return AgentHasPermission;
  }

  // const getUserID = () => {
  //   const userID =
  //     !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
  //   return userID;
  // };
  const getUserID = () => {
    let userID =
      !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
    if ((action == null || action === "edit") == false) {
      userID = subAccountId;
    }
    return userID;
  };

  const getSelectedAccountName = () => {
    const selectAccount = userProfile.subAccounts.filter(
      (x) => x.value == subAccountId
    );

    if (selectAccount.length > 0) {
      return selectAccount[0];
    }
    else {
      return false;
    }
  };

  const dismissAll = () => toast.dismiss();

  //Effect
  useEffect(() => {
    if (id != null) {
      let params = {
        language: currentLanguage,
        id: id,
        ownerId: ownerId,
      };

      dispatch(FetchGetServicesRequestByIdthunk(params));
    }

    return () => {
      dispatch(resetGetServicesRequestByIdData());
    };
  }, []);

  useEffect(() => {
    if (!!userProfile && userProfile?.haveProfileSignture != true) {
      toast.error(
        translate(
          "web.completeOwnerProfileData",
          "Please complete the personal data of the profile."
        )
      );

      setTimeout(() => {
        navigate("/profile");
      }, 3000);
    }

    if (!!userProfile && userProfile?.accountType === "Agent") {
      if (userProfile.id == subAccountId) {
        navigate("/403-Not-Authrized");
      }

      if (!CheckIfAgentHasPermission()) {
        navigate("/403-Not-Authrized");
      }
    }

    let params = {
      ownerId: getUserID(),
      skip: 0,
      take: 1000,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: "",
      sortBy: "-1",
    };
    dispatch(FetchOwnerHorsesDropDownthunk(params));

    let subOwnerProfilesParams = {
      id: getUserID(),
      langauge: currentLanguage,
    };
    dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

    dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));
  }, [currentLanguage]);

  useEffect(() => {
    if (getServicesRequestByIdData != null &&
      Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
    ) {
      setFormModel({
        ...formModel,
        eventName: getServicesRequestByIdData.eventName,
        comment: getServicesRequestByIdData.comment,
        requestsType: getServicesRequestByIdData.requestsType,
        paymentStatus: getServicesRequestByIdData.paymentStatus,
        referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,

        horse: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.horse,
        horseDrop: {
          label: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.horseName,
          value: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.horse,
        },
        birthDate: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.birthDate,
        color: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.color,
        gender: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.gender,
        origin: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.origin,
        breeder: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.breeder,
        sire: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.sire,
        dam: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.dam,
        reasons: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.reasons,
        ownerComment: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.ownerComment != null ? getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.ownerComment : "",
      });

      //another owner
      if (
        getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.ownerId !==
        getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.createdBy &&
        subOwnerProfilesByIdData.length > 0 &&
        getServicesRequestByIdData.requestsType !== "BackOffice"
      ) {
        let params = {
          ownerId: getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.ownerId,
          skip: 0,
          take: 1000,
          langauge: currentLanguage,
          horseTypeFilter: "1",
          searchValue: "",
          sortBy: "-1",
        };
        dispatch(FetchOwnerHorsesDropDownthunk(params));

        //update profile
        setProfile({
          label:
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.ownerId
            )[0].registerNo +
            " - " +
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.ownerId
            )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
          value: subOwnerProfilesByIdData.filter(
            (item) =>
              item.value == getServicesRequestByIdData.inactiveHorseRegistrationRequestDto.ownerId
          )[0].value,
        });
      }

      //options
      // setCheckedItems({
      //   option1: true,
      // });
    }
  }, [
    getServicesRequestByIdData,
  ]);

  useEffect(() => {
    if (
      toasterMessageServicesRequests != null &&
      toasterMessageServicesRequests === "save"
    ) {
      if (_isOnlinePayment.current !== "") {
        toast.success(
          translate(
            "web.yourRequestHasSubmittedSuccessfully",
            "Your Request Has Submitted Successfully"
          )
        );
      } else {
        toast.success(
          translate("web.dataSavedSuccessfully", "Data Saved Successfully")
        );
      }

      dispatch(resetToasterMessageServicesRequests());

      setTimeout(() => {
        if (_isOnlinePayment.current !== "") {
          const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${createOrEditInactiveHorseRegistrationRequestData.id}`;

          const encodeURI = encodeURIComponent(returnUrl);

          window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${createOrEditInactiveHorseRegistrationRequestData.id}&paymentType=17&userId=${localStorage.getItem(
            "EAHSUserID"
          )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
        } else {
          if (_status.current === "Submit" && formModel.eventName !== "SentBack") {
            navigate(`/profile?activeTab=${"e_services"}&serviceId=${createOrEditInactiveHorseRegistrationRequestData.id}`);
          }
          else {
            navigate(`/profile?activeTab=${"e_services"}`);
          }
        }
      }, 1000);
    }

    //error
    else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
      if (toasterMessageServicesRequests !== "errorServiceDetails") {

        toast.error(
          translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
        );

        dispatch(resetToasterMessageServicesRequests());
      }

      else if (toasterMessageServicesRequests === "errorServiceDetails") {
        toast.error(
          translate("web.createServiceRequestFailed", "Service Request Failed")
        );

        dispatch(resetToasterMessageServicesRequests());

        setTimeout(() => {
          navigate(`/profile?activeTab=${"e_services"}`);
        }, 1000);
      }
    }
  }, [toasterMessageServicesRequests]);

  useEffect(() => {
    if (getServiceDefinitionByIdData?.termsList) {
      const initialState = {};
      getServiceDefinitionByIdData.termsList.forEach((_, index) => {
        initialState[`option${index + 1}`] = false;
      });
      setCheckedItems(initialState);
    }
  }, [getServiceDefinitionByIdData?.termsList]);

  //consoles
  console.log(formModel)

  return (
    <>
      {/* loading div */}
      <div
        className={`page-overlay text-center ${servicesRequestsLoading
          ? "classdisplay"
          : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>

      {/* toast */}
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />

      {/* content page */}
      <div className={serviceRequestHeadContainer}>
        {/* update Arabian Horse Data */}
        <h2 className={serviceRequestTitle}>
          {currentLanguage === "en"
            ? getServiceDefinitionByIdData.nameEn
            : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
        </h2>

        {/* Selected Account */}
        {subOwnerProfilesByIdData.length > 0 &&
          (action == null || action === "edit") &&
          (
            <div className={userDropDown}>
              {!!userProfile && userProfile?.accountType !== "Agent" ? (
                <>
                  <NetaqInput
                    label={translate("web.selectedAccount", "Selected Account")}
                    name="selectAccount"
                    type="select"
                    listSelect={[

                      ...(!!subOwnerProfilesByIdData &&
                        !!subOwnerProfilesByIdData.length > 0 &&
                        subOwnerProfilesByIdData.map((a) => ({
                          label:
                            a?.registerNo +
                            " - " +
                            a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                          value: a.value,
                        }))),
                    ]}
                    value={profile}
                    onChange={(e) => {
                      handelSelectedAccountChange(e);
                    }}
                    placeholder={localStorage.getItem("EAHSUserFullName")}
                  />
                </>
              ) : (
                <label className="capatalize_text">
                  {getSelectedAccountName()?.registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
                </label>
              )}
            </div>
          )}
      </div>
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.horseDetails", "Horse Details")}>
        <div className={eformInput}>
          <label>
            {translate("web.horse", "Horse")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.horse", "Horse"),
                value: null,
              },
              ...(!!ownerHorsesDropDownData &&
                ownerHorsesDropDownData.map((a) => ({
                  label: a.registerNumber + " - " + a.name,
                  value: a.id,
                }))),
            ]}
            value={formModel.horseDrop}
            onChange={(e) => handleFormChange(e, "horse")}
            placeholder={translate("web.horse", "Horse")}
            name={"horse"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            key={"horse"}
            isDisabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={horseRef}
          />
          {
            errorHorse && (
              <span style={{ color: "red" }}>
                {translate("web.requiredField", "Required Field")}
              </span>
            )}
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.origin", "Origin")}
            name={"origin"}
            type={"text"}
            disabled={true}
            value={formModel.origin}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.breeder", "Breeder")}
            name={"breeder"}
            type={"text"}
            disabled={true}
            value={formModel.breeder}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.gender", "Gender")}
            name={"gender"}
            type={"text"}
            disabled={true}
            value={translate(
              `web._${formModel.gender.toLowerCase()}`,
              formModel.gender
            )}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.color", "Color")}
            name={"color"}
            type={"text"}
            value={
              formModel.color
            }
            disabled={true}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.birthDate", "Birth Date")}
            name={"birthDate"}
            type={"text"}
            disabled={true}
            value={
              formModel.birthDate
            }
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.sire", "Sire")}
            name={"sire"}
            type={"text"}
            disabled={true}
            value={formModel.sire}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.dam", "Dam")}
            name={"dam"}
            type={"text"}
            disabled={true}
            value={formModel.dam}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.reasons", "Reasons")}
            name={"reasons"}
            type={"textarea"}
            required={true}
            maxchars={1150}
            value={formModel.reasons}
            onChange={handleFormChange}
            isDisabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={reasonRef}
          />
          {
            errorReasons && (
              <span style={{ color: "red" }}>
                {translate("web.requiredField", "Required Field")}
              </span>
            )}
        </div>
      </EahsForm>

      {/* Comments */}
      {(!!formModel.comment || !!formModel.ownerComment) && (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
          {!!formModel.comment && (
            // eahs Comment
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.eahsComments", "EAHS Comments")}
                name={"adminComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.comment}
                disabled={true}
              />
            </div>
          )}

          {(!!formModel.ownerComment || formModel.eventName === "SentBack") && (
            // owner Comment 
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.ownerComment", "Owner Comment")}
                name={"ownerComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.ownerComment}
                onChange={handleFormChange}
                disabled={formModel.eventName !== "SentBack" ? true : false}
              />
            </div>
          )}
        </EahsForm>
      )}

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
          return (
            <div className={eformTerms} key={index}>
              <NetaqInput
                type={"checkbox"}
                label={item}
                name={`option${index + 1}`}
                checked={checkedItems[`option${index + 1}`] || action != null}
                onChange={handleCheckboxChange}
                disabled={formModel.eventName !== ""}
              />
            </div>
          );
        })}
      </EahsForm>

      {/* <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.ServiceGeneralNote",
              "Service General Note"
            )}
            name="option1"
            checked={checkedItems.option1}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
      </EahsForm> */}

      {/* buttons*/}
      <div className={eFormButtonsContainer}>
        {/* draft/pay/submit btn */}
        {(
          (action == null || action === "edit")
          ||
          (
            action === "approve"
            &&
            (
              formModel.eventName === "SentBack"
              ||
              (formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice")
            )
          )
        ) && (
            <>
              {(formModel.eventName === "" || formModel.eventName === "Draft") &&
                <DraftBtn onClick={() => handelFormSubmit("Draft", "", "Draft")}
                  isDisabled={
                    formModel.eventName === "" ||
                      formModel.eventName === "Draft"
                      ? false
                      : true
                  } />
              }

              {userProfile?.participateWithoutPayment === true && formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                <ApproveAndPayLaterBtn
                  selectedAccountId={profile?.value}
                  isApprove={false}
                  onClick={() =>
                    handelFormSubmit("Draft", "no", 'Pay')
                  }
                  isDisabled={
                    formModel.eventName === "SentBack"
                      ? true
                      : false
                  }
                />
              )}

              {formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                <SubmitAndPay
                  selectedAccountId={profile?.value}
                  onClick={() =>
                    handelFormSubmit("Draft", "yes", 'Pay')
                  }
                  isDisabled={
                    formModel.eventName === "SentBack"
                      ? true
                      : false
                  }
                />
              )}

              {(getServiceDefinitionByIdData.serviceFees === 0 || (formModel.eventName === "SentBack" && action !== "view")) && (
                <SubmitServiceBtn
                  onClick={() =>
                    handelFormSubmit("Submit", "", 'Submit')
                  }
                  isDisabled={
                    getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack"
                      ? false
                      : true
                  }
                />
              )}
            </>
          )}
      </div>
    </>
  );
}
